// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import cartPageStyles from "@guestsupply/App/SharedStyles/CartPageStyles";
import { cartActionsStyles } from "@guestsupply/Overrides/Widgets/Cart/CartActions";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

cartActionsStyles.narrowHidden = {
    above: "sm",
    css: css`
        display: flex;
        justify-content: flex-end;
    `,
};
cartActionsStyles.wideHidden = {
    below: "md",
    css: css`
        display: flex;
        justify-content: flex-end;
    `,
};
cartActionsStyles.saveOrderButton = {
    buttonType: "outline",
    variant: "secondary",
};
cartActionsStyles.wideOverflowMenu = {
    cssOverrides: {
        wrapper: css`
            margin-left: 20px;
        `,
    },
};
cartActionsStyles.wrapper = {
    css: css`
        display: flex;
        column-gap: 32px;
        row-gap: 16px;
        flex-wrap: wrap;
        margin-top: 20px;
        margin-bottom: 8px;
        ${xScreen("lte", "sm")} {
            flex-direction: column;
        }
    `,
};
cartActionsStyles.saveOrderLink = {
    ...cartPageStyles.cartActions?.saveOrderLink,
};
cartActionsStyles.addAllToListClickable = {
    ...cartPageStyles.cartActions?.addAllToListClickable,
};
cartActionsStyles.checkoutLink = {
    ...cartPageStyles.cartActions?.checkoutLink,
};
cartActionsStyles.requestQuoteLink = {
    ...cartPageStyles.cartActions?.requestQuoteLink,
};
cartActionsStyles.removeAllLink = {
    ...cartPageStyles.cartActions?.removeAll,
};
cartActionsStyles.printLink = {
    ...cartPageStyles.cartActions?.printLink,
};
cartActionsStyles.saveAndPrintWrapper = {
    css: css`
        display: flex;
        align-items: baseline;
        gap: 32px;
    `,
};
cartActionsStyles.removeAndAddAllToListWrapper = {
    css: css`
        flex: 1;
        display: flex;
        align-items: baseline;
        justify-content: space-between;
    `,
};
cartActionsStyles.removeAllConfirmationModalStyles = {
    modal: {
        sizeVariant: "medium",
    },
};
